import posthog from 'posthog-js';

const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
let ready = false;

export function initAnalytics(): void {
  if (!key || ready) return;
  posthog.init(key, { api_host: 'https://us.i.posthog.com', capture_pageview: 'history_change', person_profiles: 'identified_only' });
  ready = true;
}

export function capture(event: string, props?: Record<string, unknown>): void {
  if (ready) posthog.capture(event, props);
}

export function identify(id: string, props?: Record<string, unknown>): void {
  if (!ready) return;
  posthog.identify(id, props);
  // El equipo queda marcado en este navegador; los tableros de PostHog lo excluyen.
  if (props?.internal) posthog.register({ internal: true });
}
